import classNames from "classnames";

const clsx = (...arg) => {
  return classNames(...arg);
};

export default clsx;